/* eslint-disable import/no-anonymous-default-export */

const EFluidType = {
  SOLVENT: { code: 'SOLVENT', description: 'Solvente', label: 'Solvente' },
  BORRA: { code: 'BORRA', description: 'Borra', label: 'Borra' },
  WATER: { code: 'WATER', description: 'Água', label: 'Água' },
  YELLOW_SOLVENT: { code: 'YELLOW_SOLVENT', description: 'Solvente Amarelo', label: 'Solvente Amarelo' },
  // Recarga: usado apenas em descargas (RC que sai da máquina e reentra depois).
  RC: { code: 'RC', description: 'Recarga', label: 'Recarga' },
};

EFluidType.getByCode = (code) => Object.values(EFluidType).find(t => t && t.code === code) || null;
EFluidType.asOptions = () => Object.values(EFluidType)
  .filter(t => t && t.code)
  .map(t => ({ value: t.code, label: t.description }));

export default EFluidType;
